import { useEffect } from "react";

export function useAutoResponsiveViewportSwitchForModal(modalOpen: boolean) {
  useEffect(() => {
    const viewport = document.querySelector('meta[name="viewport"]');
    if (viewport) {
      if (modalOpen) {
        window.setTimeout(() => {
          viewport.setAttribute(
            "content",
            "width=device-width, initial-scale=1"
          );
        }, 100);
      } else {
        viewport.setAttribute("content", "width=1024");
      }
    }
  }, [modalOpen]);
}
